<template>
    <login-card>
        <section v-if="showWishlistHelper" class="login-help-text">
            {{ $t('login.help.wishlist') }}
        </section>
        <section class="login-header">
            <button @click="loginMode = 'login'" :class="buttonModeClass('login')">
                {{ $t('login.loginButton') }}
            </button>
            <button @click="loginMode = 'register'" :class="buttonModeClass('register')">
                {{ $t('login.registerButton') }}
            </button>
        </section>

        <b-card-body>
            <section v-if="loginMode === 'login'" class="login-card--init">
                <bank-id
                    v-if="siteSupportsBankID"
                    @started="hideEmail = true" @update="handleLogin"
                    :key="bankIdReset"></bank-id>
                <b-button v-if="hideEmail" @click="resetLogin">{{ $t('login.goBack') }}</b-button>
                <div v-if="!hideEmail" class="mt-3">
                    <divider v-if="siteSupportsBankID" :title="$t('login.or')"></divider>
                    <email-password @update="handleLogin"/>
                </div>
            </section>

            <section v-if="loginMode === 'register'">
                <register @update="handleLogin"></register>
                <b-button @click="loginMode = 'login'">{{ $t('login.goBack') }}</b-button>
            </section>
        </b-card-body>
    </login-card>
</template>
<script>
import { defineComponent } from 'vue';
import PageLayout from '@components/Layout/PageLayout.vue';
import AlignRight from '@components/Layout/AlignRight.vue';
import BankId from '@components/App/Login/BankId.vue';
import EmailPassword from '@components/App/Login/EmailPassword.vue';
import Register from '@components/App/Login/Register.vue';
import { useUserStore } from '@stores/User';
import Divider from '@components/Divider.vue';
import LoginCard from '@components/App/Login/LoginCard.vue';
import { useAppStore } from '@stores/App';

export default defineComponent({
    components: { LoginCard, Divider, Register, EmailPassword, AlignRight, PageLayout, BankId },
    data() {
        return {
            app: useAppStore(),
            bankIdReset: 0,
            loginMode: 'login',
            email: null,
            password: null,
            hideEmail: false,
            modes: {
                login: 'login',
                register: 'register',
            },
        };
    },
    computed: {
        showWishlistHelper() {
            const user = useUserStore();
            const path = user?.redirect_to?.fullPath || this.$route.fullPath;
            return path.includes('list');
        },
        siteSupportsBankID() {
            const isDev = this.app.isDevelopment();
            const items = [
                'newport.se',
            ];
            let supports = isDev;

            items.forEach(function (item) {
                if (location.host.includes(item)) {
                    supports = true;
                }
            });

            return supports;
        }
    },
    methods: {
        resetLogin() {
            this.hideEmail = false;
            this.bankIdReset = this.bankIdReset + 1;
        },
        buttonModeClass(mode) {
            const classes = [ 'np-login-button' ];

            if (mode === this.loginMode) {
                classes.push('np-login-button--active');
            }

            return classes;
        },
        async handleLogin(event) {
            const user = await useUserStore();
            user.login(event, this.$route?.query?.redirectTo);
        },
    }
});
</script>
<style lang="scss" scoped>
.login-header {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
    background: white;
    height: 80px;
}

.login-help-text {
    background: var(--theme-bg);
    color: var(--theme-title-color);
    padding: 2rem;
    text-align: center;
}

.np-login-button {
    border: none;
    background: #f0f0f0;
    height: 80px;
    color: #333333;

    &--active {
        background: white;
    }
}
</style>
